export default {
    ca: {
        heading: {
            slogan: 'Explora mapes d\'altres usuaris i dades de diverses fonts',
            cta: 'Crear un mapa',
        },
        stats: {
            availableMaps: 'Mapes disponibles',
            lastUpdate: 'Última actualització',
        },
    },
    es: {
        heading: {
            slogan: 'Explora mapas de otros usuarios y datos de diversas fuentes',
            cta: 'Crear un mapa',
        },
        stats: {
            availableMaps: 'Mapas disponibles',
            lastUpdate: 'Última actualización',
        },
    },
    en: {
        heading: {
            slogan: 'Explore maps of other users and data from various sources',
            cta: 'Create a map',
        },
        stats: {
            availableMaps: 'Available maps',
            lastUpdate: 'Last update',
        },
    },
};



// WEBPACK FOOTER //
// ./src/gallery/components/gallery-featured/gallery-featured-translations.js